import * as React from "react";
import {IApplicationGuard, TypeDefs, lazyInject} from "@athena-portal/core";

export class LoginPage extends React.Component {
    @lazyInject(TypeDefs.ApplicationGuard)
    private applicationGuard: IApplicationGuard;

    public async componentDidMount() {
        const url = new URL(window.location.href);
        const redirectUri = url.searchParams.get("redirect_uri");
        if (redirectUri) {
            this.applicationGuard.getLoginUrl(redirectUri).subscribe(
                (registerUrl: string) => {
                    window.location.replace(registerUrl);
                }
            )
        }
    }

    public render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/pages/LoginPage.tsx